import axios from "axios"
import { config } from "../../config"
import store from "../../redux/store"


const protocol = process.env.REACT_APP_NIFFLER_BACKEND_PROTOCOL;
const url = process.env.REACT_APP_NIFFLER_BACKEND_HOST;
const port = process.env.REACT_APP_NIFFLER_BACKEND_PORT;
const nifflerURL = `${protocol}${url}${port}`


const getRetentionView = (products, groupBy = 'customer') => {

    return new Promise((resolve, reject) => {

        axios.post(`${nifflerURL}/statistics/getRetentionView`, {
            products, groupBy
        })
        .then(res => {
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}



const getRetentionViewAdvanced = (products, groupBy = 'customer') => {

    return new Promise((resolve, reject) => {

        axios.post(`${nifflerURL}/statistics/getRetentionViewAdvanced`, {
            products, groupBy
        })
        .then(res => {
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}



const getBreakdownView = (products, from, to, groupBy = 'customer') => {

    return new Promise((resolve, reject) => {

        axios.post(`${nifflerURL}/statistics/getBreakdownView`, {
            products, from, to, groupBy
        })
        .then(res => {
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}


const getStatisticsSummary = (products, from, to, groupBy = 'customer') => {

    return new Promise((resolve, reject) => {

        axios.post(`${nifflerURL}/statistics/getStatisticsSummary`, {
            products, from, to, groupBy
        })
        .then(res => {
            resolve(res)
        })
        .catch(() => {
            resolve(false);
        })
    })
}


export {
    getRetentionView,
    getRetentionViewAdvanced,
    getBreakdownView,
    getStatisticsSummary
};
